import React from 'react';
import { Grid } from '@axaou/ui';
import { useQuery } from '@axaou/ui';
import { axaouDevUrl, cacheEnabled, pouchDbName } from '../Query';
import { useSetRecoilState } from 'recoil';
import {
  ancestryGroupAtom,
  AncestryGroupCodes,
} from '../sharedState';
import { RightArrow } from '../UserInterface';
import { LoadedAnalysis } from '../types';
import { useAppNavigation } from '../hooks/useAppNavigation';



interface Data {
  availableAnalyses: LoadedAnalysis[];
}

const AvailableAnalyses: React.FC = () => {
  const { goToPhenotype, openDetailPane } = useAppNavigation();
  const setAncestryGroup = useSetRecoilState(ancestryGroupAtom);

  const { queryStates, anyLoading } = useQuery<Data>({
    dbName: pouchDbName,
    queries: [
      {
        url: `${axaouDevUrl}/analyses-loaded`,
        name: 'availableAnalyses',
      },
    ],
    deps: [],
    cacheEnabled,
  });

  const availableAnalysesState = queryStates.availableAnalyses;

  if (!availableAnalysesState) {
    throw new Error('Query state for available analyses not found.');
  }

  const { data, error } = availableAnalysesState;

  console.log(data)

  const columns = [
    {
      key: 'analysis_id',
      heading: 'Analysis ID',
      isSortable: true,
      minWidth: 150,
    },
    {
      key: 'details',
      heading: 'Details',
      isSortable: false,
      minWidth: 250,
      render: (row: LoadedAnalysis) => {
        const details = row.details.map((detail) => {
          const seqAbbrev = detail.sequencing_type.startsWith('g') ? 'G' : 'E';
          return (
            <span
              style={{
                display: 'inline-block',
                padding: '4px 8px',
                margin: '2px',
                borderRadius: '12px',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: '0.85em',
              }}
              key={`${seqAbbrev}-${detail.ancestry_group}`}
            >
              {`${seqAbbrev}-${detail.ancestry_group}`}
            </span>
          );
        });
        return <div>{details}</div>;
      },
    },
    {
      key: 'show',
      heading: 'Show',
      isSortable: false,
      minWidth: 80,
      render: (row: LoadedAnalysis) => {
        const handleClick = () => {
          goToPhenotype(row.analysis_id, { resultIndex: 'pheno-info' });
          openDetailPane();
        };

        return <RightArrow onClick={handleClick} />;
      },
    },
  ];

  if (anyLoading()) {
    return <div>Loading...</div>;
  }

  if (error) {
    console.log(`Failed to load analysis data: ${error.message}`);
    return <div>Error: Failed to load analysis data</div>;
  }

  if (!data) {
    return <div>No analyses available.</div>;
  }

  return (
    <Grid
      columns={columns}
      data={data}
      rowKey={(row: LoadedAnalysis) => row.analysis_id}
      numRowsRendered={20}
    />
  );
};

export default AvailableAnalyses;
